import cn from "classnames";
import { If } from "components";
import { t } from "i18next";

import { FilterChipsProps } from "./FilterChips.types";

import styles from "./FilterChips.module.scss";

/** A segmented filter that stays visible, for the one filter people flip most. */
const FilterChips = ({
  label,
  options,
  value,
  disabled,
  onChange
}: FilterChipsProps) => {
  return (
    <div className={styles.chips}>
      <If condition={!!label}>
        <span className={styles.chips_label}>{t(String(label))}</span>
      </If>

      <div className={styles.chips_list}>
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            disabled={disabled}
            className={cn(styles.chips_chip, {
              [styles.chips_chip__active]: option.value === value
            })}
            onClick={() => onChange(option.value)}
          >
            {t(option.label)}

            <If condition={option.counter !== undefined}>
              <span className={styles.chips_counter}>{option.counter}</span>
            </If>
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterChips;
